import { useState, useCallback, useEffect } from "react";
import { api } from "../api/api";

const useUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(false);

  const carregarUsuarios = useCallback(async (
    search = "",
    page = 1,
    limit = 1000 // Limite maior para garantir o mapeamento completo dos IDs
  ) => {
    setLoading(true);
    try {
      const response = await api.get("/users", {
        params: {
          search,
          page,
          limit
        }
      });

      const data = response.data;
      const listaFinal = Array.isArray(data)
        ? data
        : data.data || data.users || [];

      setUsuarios(listaFinal);
      return data;
    } catch (error) {
      console.error(
        "Erro ao carregar usuários:",
        error
      );

      setUsuarios([]);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  // 🚀 Carrega os usuários automaticamente assim que o hook é montado
  useEffect(() => {
    carregarUsuarios();
  }, [carregarUsuarios]);

  const cadastrarUsuario = useCallback(async (dados) => {
    const dadosTratados = Object.keys(dados).reduce(
      (acc, key) => {
        const valor = dados[key];

        if (
          key !== "senha" &&
          typeof valor === "string"
        ) {
          acc[key] = valor.trim().toLowerCase();
        } else {
          acc[key] = valor;
        }

        return acc;
      },
      {}
    );

    const response = await api.post(
      "/auth/register",
      dadosTratados
    );

    const novoUsuario = response.data?.user || response.data?.data || response.data;

    setUsuarios((prev) => [
      ...prev,
      novoUsuario
    ]);

    return response.data;
  }, []);

  const atualizarUsuario = useCallback(async (
    usuarioId,
    dados
  ) => {
    const response = await api.put(
      `/users/${usuarioId}`,
      dados
    );

    const usuarioAtualizado = response.data?.user || response.data?.data || response.data;

    setUsuarios((prev) =>
      prev.map((usuario) =>
        String(usuario._id || usuario.id) === String(usuarioId)
          ? usuarioAtualizado
          : usuario
      )
    );

    return response.data;
  }, []);

  const resetSenha = useCallback(async (
    usuarioId,
    novaSenha
  ) => {
    if (!novaSenha) {
      throw new Error(
        "Digite a nova senha"
      );
    }

    const response = await api.put(
      `/users/${usuarioId}/reset-senha`,
      {
        novaSenha
      }
    );

    return response.data;
  }, []);

  return {
    usuarios,
    loading,
    carregarUsuarios,
    cadastrarUsuario,
    atualizarUsuario,
    resetSenha
  };
};

export default useUsuarios;